const TagColors = {
    gin: "#7856a1",
    vodka: "#5096ab",
    rum: "#d6a038",
    tequila: "#6f8548",
    mezcal: "#6f8548",
    whiskey: "#d66d2a",
    bourbon: "#d66d2a",
    rye: "#d66d2a",
    scotch: "#d66d2a",
    aperol: "#ff3c00f3",
    champagne: "#c18d51",
    bitters: "#8e522f",
    chartreuse: "#405927",
    sake: "#233758",
    brandy: "#800020",
    cognac: "#800020",
    liqueur: "#687387",
    none: "#13447d",
    spirit: "#be54c4", //this is the color for spirits not on the list above
    glass: "#709DD8",
    style: "#696db8",
    taste: "#d61616ec",
    mix: "#687387",
    color: "#687387",
    season: "#687387",
    temp: "#687387",
    top_pick: "#be8902",
    misc: "#687387"
};

export default TagColors;